/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCandidateUntemplatedHover/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCandidateUntemplatedHover({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/AppointmentCandidateUntemplatedHover"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let timegridValueData = fromData.useDataFormat({ viewPath,
context: 'timegrid',
format: fromHelpers.displayZoomIn,
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsRed700alpha50 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700alpha.50'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromFormat.formatTimegridAppointmentTime,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let eventDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'description',
})
  return (<React.Fragment
>
<div
  data-testid="AppointmentCandidateUntemplatedHover.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-1f3zuj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-3-1f3zuj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-4-1f3zuj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-5-1f3zuj': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-6-1f3zuj': dtColorsRed700alpha50,'--c-1-1f3zuj': timegridValueData ? "zoom-in" : "pointer"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentCandidateUntemplatedHover.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-7-1f3zuj': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-8-1f3zuj': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-1f3zuj': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-10-1f3zuj': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="AppointmentCandidateUntemplatedHover.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="event"
 format="/Data/format.js formatTimegridAppointmentTime"
 text={eventValueData}
 weight="medium"
 size="small"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="event.description"
 text={eventDescriptionValueData}
 weight="medium"
 size="small"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}